import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface AuditLogDto {
  id: number;
  userId: number | null;
  userEmail: string | null;
  category: string;
  message: string | null;
  ipAddress: string | null;
  createdAt: string;
}

export interface AuditLogPage {
  total: number;
  page: number;
  pageSize: number;
  rows: AuditLogDto[];
}

export interface AuditLogFilter {
  category: string;
  from: string;
  to: string;
  userId: number | null;
}

/** What the table asks for on top of the filter bar. */
export interface AuditLogQuery {
  search?: string;
  sort?: string;
  desc?: boolean;
  page: number;
  pageSize: number;
}

@Injectable({ providedIn: 'root' })
export class AuditLogService {
  constructor(private http: HttpClient) {}

  get(filter: AuditLogFilter, query: AuditLogQuery): Observable<AuditLogPage> {
    let params = new HttpParams()
      .set('page', query.page.toString())
      .set('pageSize', query.pageSize.toString());

    if (filter.category)  params = params.set('category', filter.category);
    if (filter.from)      params = params.set('from', filter.from);
    if (filter.to)        params = params.set('to', filter.to);
    if (filter.userId)    params = params.set('userId', filter.userId.toString());
    if (query.search)     params = params.set('search', query.search);
    if (query.sort)       params = params.set('sort', query.sort)
                                        .set('desc', String(query.desc));

    return this.http.get<AuditLogPage>('/api/audit-log', { params });
  }
}
